export default __webpack_public_path__ + "static/media/kungfu-slap.77799410.mp3";